import {
  BookOutlined,
  FileOutlined,
  HomeOutlined,
  ProfileOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';

export interface IRoute {
  path: string;
  title: string;
  description?: string;
  permission?: string;
  icon?: any;
  children?: IRoute[];
  isAdmin?: boolean;
}

export enum Route {
  PAGE500 = 'PAGE500',
  PAGE403 = 'PAGE403',

  LOGIN = 'LOGIN',

  HOME = 'HOME',
  SETTING = 'SETTING',
  FILE = 'FILE',
  CATEGORY = 'CATEGORY',
  POST = 'POST',
  POST_CREATE = 'POST_CREATE',
  POST_EDIT = 'POST_EDIT',
  CUSTOMER = 'CUSTOMER',
}

export const Routes: { [key in Route]: IRoute } = {
  PAGE500: {
    path: '/loi',
    title: 'Lỗi hệ thống',
  },
  PAGE403: {
    path: '/loi-quyen-truy-cap',
    title: 'Lỗi quyền truy cập',
  },

  LOGIN: {
    path: '/dang-nhap',
    title: 'Đăng nhập',
  },

  HOME: {
    path: '/',
    title: 'Trang chủ',
    icon: <HomeOutlined />,
  },

  FILE: {
    path: '/tep-tin',
    title: 'Tệp tin',
    icon: <FileOutlined />,
  },
  CATEGORY: {
    path: '/danh-muc',
    title: 'Danh mục',
    icon: <BookOutlined />,
  },
  POST: {
    path: '/bai-viet',
    title: 'Bài viết',
    icon: <ProfileOutlined />,
  },
  POST_CREATE: {
    path: '/them-moi-bai-viet',
    title: 'Thêm mới bài viết',
  },
  POST_EDIT: {
    path: '/chinh-sua-bai-viet',
    title: 'Chỉnh sửa bài viết',
  },

  SETTING: {
    path: '/cai-dat',
    title: 'Cài đặt',
    icon: <SettingOutlined />,
    isAdmin: true,
  },
  CUSTOMER: {
    path: '/khach-hang',
    title: 'Khách hàng',
    icon: <UserOutlined />,
    isAdmin: true,
  },
};
